import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type THIS_API = ApiDefinition['/my/accounts-with-creators']['GET'];
type Output = THIS_API['response'];

const getMyAccountsWithCreators = async (): Promise<Output> => {
  const response = await noodleApiClient.get('/my/accounts-with-creators');
  return response.data;
};

export default getMyAccountsWithCreators;
